import { render, staticRenderFns } from "./AdviceModal.vue?vue&type=template&id=e1b93f6c"
import script from "./AdviceModal.vue?vue&type=script&lang=js"
export * from "./AdviceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports